import { render } from "./News07.vue?vue&type=template&id=8f6ddc26&scoped=true"
import script from "./News07.vue?vue&type=script&lang=js"
export * from "./News07.vue?vue&type=script&lang=js"

import "./News07.vue?vue&type=style&index=0&id=8f6ddc26&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f6ddc26"]])

export default __exports__